import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PrismicRichText from "../components/PrismicRichText";
import { get, map, find } from "lodash";
import styled from "styled-components";
import COA from "../COA";
import cx from "classnames";

const StlSection = styled.section`
  background: #0095cd;
  padding-bottom: 40px;
`;

const StlWrapper = styled.div`
  padding: 30px 0;
  h1 {
    color: #e0fc01;
    font-size: 50px;
    line-height: 1;
    text-align: center;
    @media (min-width: 1100px) {
      font-size: 80px;
      margin-bottom: 45px;
    }
  }
  .name {
    padding: 25px 0 10px;
    font-size: 22px;
  }
  .coa-wrapper {
    padding: 20px;
    margin-top: 30px;
    display: grid;
    grid-gap: 60px;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    @media (min-width: 800px) {
      grid-gap: 40px;
    }
  }
`;

export default function COASlice(slice) {
  const copy = get(slice, "primary.heading");
  const dataBody = useSelector((state) =>
    get(state, "prismic.custom_page.data.body", [])
  );
  const linkedCOAs = get(
    find(dataBody, { slice_type: "coa_slice" }),
    "items",
    []
  );

  const renderCOA = map(linkedCOAs, (el, i) => (
    <COA key={i} id={get(el, "linked_coas.id")} />
  ));

  return (
    <StlSection className="text-section standard-padding-less desktop-padding-70">
      <StlWrapper>
        <PrismicRichText render={copy} />
        <div className={cx("coa-wrapper")}>{renderCOA}</div>
      </StlWrapper>
    </StlSection>
  );
}
